<template>
  <div>
    <editor></editor>


    <div style="width: 200px">
      <date-picker v-model="aa" day="end"></date-picker>
    </div>
    <pagination :page="1" :pages="{total:500,size:20}" @on-search="search"></pagination>
    <load-button text="搜索" @on-click="show"></load-button>
    <smart-table :table-label="labels" :table-data="tableData" :table-opt="opt" :loading="loading"></smart-table>
    <dropdown v-model="aa" :data-list="list"></dropdown>
    <time-picker v-model="aa"></time-picker>
    {{aa}}
    <form-dialog title="这是哥标题" ref="model" width="600px">
      <div slot="dialog-main">
        <el-form>
          <el-form-item label="活动名称" label-width="100px">
            <el-input v-model="form.name" auto-complete="on"></el-input>
          </el-form-item>
          <el-form-item label="活动区域" label-width="100px">
            <dropdown v-model="form.area" :data-list="list"></dropdown>
          </el-form-item>
        </el-form>
      </div>

    </form-dialog>
    <!--<tree tree-url="/webServer/department/tree"></tree>-->
    <chart-tree></chart-tree>
    <upload-img v-model="url"  size="200" file-name="test" type="headImg"></upload-img>
  </div>
</template>

<script>
  import DatePicker from "./DatePicker";
  import Pagination from "./Pagination";
  import LoadButton from "./LoadButton";
  import SmartTable from "./SmartTable";
  import Dropdown from "./Dropdown";
  import TimePicker from "./TimePicker";
  import FormDialog from "./FormDialog";
  import ChartTree from "./ChartTree";
  import UploadImg from "./UploadImg";
  import Editor from "./Editor";
  export default {
    components: {
      Editor,
      UploadImg,
      ChartTree,
      FormDialog,
      TimePicker,
      Dropdown,
      SmartTable,
      LoadButton,
      Pagination,
      DatePicker,
    },
    name: 'HelloWorld',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        aa: null,
        form: {},
        loading:false,
        canclick: true,
        list: [{id: 1, name: 'haha'}, {id: 2, name: 'fff'}, {id: 3, name: 'gggg'}, {id: 4, name: 'gggg'}, {id: 5, name: 'gggg'}, {id: 6, name: 'gggg'}, {id:7, name: 'gggg'}, {id: 8, name: 'gggg'}, {id: 9, name: 'gggg'}, {id: 10, name: 'gggg'}],
        labels: [
          {prop: 'date', label: '时间', width: '300px'},
          {prop: 'name', label: '姓名', width: '300px'},
          {prop: 'province', label: '省份', width: '300px'},
          {prop: 'city', label: '城市', width: '300px'},
          {prop: 'zip', label: '状态', width: '300px', map: this.globalData.status},
        ],

        opt: [
          {label: '删除', fn: this.search},
          {label: '编辑', fn: this.search1}
        ],
        tableData: [{
          date: 1522318938422,
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 1
        }, {
          date: 1522318938422,
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 2
        }, {
          date: 1522318938422,
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 2
        }, {
          date: 1522318938422,
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 1
        }],
        url:''

      }
    },
    mounted(){
//      console.log(this)
      console.log(this.globalData.host)
    },
    methods: {
      show(stop){
        this.loading = true
        setTimeout(() => {this.loading = false,stop()},2000)
      },
      search(page){
        this.$fnConfirm('确定删除？', () => {
          console.log(this)
        })

      },
      search1(page){
        console.log(page)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue